import React from "react";
import {
  FaBoxesPacking,
  FaCreditCard,
  FaTruckArrowRight,
  FaTruckFast,
  FaTruckRampBox,
} from "react-icons/fa6";
import { OrderProgressContainer } from "../styled";

const currentIndex = 2;
const orderProgress = [
  { label: "결제완료", icon: FaCreditCard },
  { label: "상품준비", icon: FaTruckRampBox },
  { label: "배송시작", icon: FaTruckArrowRight },
  { label: "배송중", icon: FaTruckFast },
  { label: "배송완료", icon: FaBoxesPacking },
];

const OrderProgress = () => {
  return (
    <OrderProgressContainer>
      <div className="info">
        <p>
          <strong>5.9(금)</strong> 상품 배송이 시작되었습니다.
        </p>
        <p>고객님의 상품을 배송중입니다.</p>
      </div>
      <ul>
        {orderProgress.map((item, index) => (
          <li className={index <= currentIndex ? "active" : ""} key={index}>
            <item.icon />
            <span>{item.label}</span>
            <div className="dot"></div>
          </li>
        ))}
      </ul>
    </OrderProgressContainer>
  );
};

export default OrderProgress;
